/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StarHalfIcon16Solid = forwardRef('StarHalfIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8 .446A.74.74 0 0 0 7.311.9L5.547 4.997l-4.442.411a.75.75 0 0 0-.425 1.31l3.35 2.945-.98 4.351a.75.75 0 0 0 1.115.81L8 12.547V.447Z" })));
});
